export const smallHeadText = {
  fontFamily: 'Poppins',
  fontSize: { xl: '20px', lg: '20px', md: '15px', sm: '13px', xs: '13px' },
  fontWeight: 300,
  color: 'rgba(35, 36, 42, 1)',
  letterSpacing: '0.11em',
  textTransform: 'uppercase',
  textAlign: { xl: 'left', lg: 'left', md: 'left', sm: 'center', xs: 'center' },
};

export const headText = {
  mt: 1,
  fontFamily: 'Poppins',
  fontSize: { xl: '30px', lg: '32px', md: '18px', sm: '19px', xs: '16px' },
  fontWeight: 500,
  letterSpacing: '0.01em',
  color: 'rgba(35, 36, 42, 1)',
  textAlign: { xl: 'left', lg: 'left', md: 'left', sm: 'center', xs: 'left' },
  width: { xl: '30%', lg: '30%', md: '100%', sm: '100%', xs: '100%' },
  lineHeight: { xl: '32px', lg: '32px', md: '32px', sm: '20px', xs: '16px' },
  ml: { xl: 0, lg: 0, md: 2, sm: 2, xs: 2 },
};
export const headMainText = {
  mt: 1,
  fontFamily: 'Poppins',
  fontSize: { xl: '30px', lg: '32px', md: '18px', sm: '20px', xs: '18px' },
  fontWeight: 500,
  letterSpacing: '0.01em',
  color: 'rgba(35, 36, 42, 1)',
  textAlign: { xl: 'left', lg: 'left', md: 'left', sm: 'center', xs: 'center' },
  width: {
    xl: '90%',
    lg: '90%',
    md: '100%',
    sm: '100%',
    xs: '100%',
  },
  mx: 'auto',
  lineHeight: { xl: '32px', lg: '32px', md: '32px', sm: '26px', xs: '18px' },
};

export const categoryText = {
  fontFamily: 'poppins',
  fontSize: { xl: '14px', lg: '14px', md: '12px', sm: '9px', xs: '9px' },
  fontWeight: 400,
  color: 'rgba(0, 0, 0, 1)',
  py: 0.8,
};

export const insideCategoryBox = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 2,
  background: 'rgba(255, 255, 255, 1)',
  boxShadow: '0px 10px 20px rgba(220, 220, 220, 0.5)',
  borderRadius: { xl: '10px', lg: '10px', md: '10px', sm: '5px', xs: '5px' },
  width: 'auto',
  height: 'auto',
  px: 3,
  mt: 1,
  cursor: 'pointer',
  '&:hover': {
    boxShadow: '1px 1px 30.6px 1px rgba(47, 63, 87, 0.08)',
  },
};
export const insideCategorySmallBox = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: 2,
  background: 'rgba(255, 255, 255, 1)',
  boxShadow: '0px 10px 20px rgba(220, 220, 220, 0.5)',
  borderRadius: { xl: '10px', lg: '10px', md: '10px', sm: '5px', xs: '5px' },
  minWidth: '120px',
  maxWidth: '120px',
  height: 'auto',
  px: 2,
  mt: 1,
  cursor: 'pointer',
  '&:hover': {
    boxShadow: '1px 1px 30.6px 1px rgba(47, 63, 87, 0.08)',
  },
};

export const ExlporeBtn = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '15px',
  background: 'rgba(108, 108, 162, 1)',
  p: 1,
  fontFamily: 'Poppins',
  fontSize: {
    xl: '16px',
    lg: '16px',
    md: '16px',
    sm: '12px',
    xs: '12px',
  },
  cursor: 'pointer',
  fontWeight: 600,
  color: 'rgba(255, 255, 255, 1)',
  minWidth: { xl: '200px', lg: '200px', md: '200px', sm: '150px', xs: '150px' },
  mb: { xl: 0, lg: 0, md: 2, sm: 2, xs: 2 },
};

export const sellerBox = {
  width: {
    xl: '54%',
    lg: '55%',
    md: '100%',
    sm: '100%',
    xs: '100%',
  },
  display: 'flex',
  justifyContent: {
    xl: 'flex-start',
    lg: 'flex-start',
    md: 'center',
    sm: 'center',
    xs: 'center',
  },
  flexDirection: {
    xl: 'start',
    lg: 'start',
    md: 'center',
    sm: 'center',
    xs: 'center',
  },
  flexWrap: 'wrap',
  gap: 2,
};

export const headTextColor = {
  mt: 1,
  fontFamily: 'Poppins',
  fontSize: { xl: '32px', lg: '32px', md: '18px', sm: '16px', xs: '16px' },
  fontWeight: 500,
  letterSpacing: '0.01em',
  color: 'rgba(35, 36, 42, 1)',
  textAlign: { xl: 'left', lg: 'left', md: 'left', sm: 'center', xs: 'center' },
  width: '100%',
  lineHeight: { xl: '32px', lg: '32px', md: '32px', sm: '26px', xs: '26px' },
};

export const subTrustText = {
  fontFamily: 'Poppins',
  fontSize: { xl: '20px', lg: '20px', md: '18px', sm: '12px', xs: '12px' },
  fontWeight: 400,
  color: 'rgba(35, 36, 42, 1)',
  textAlign: 'center',
};

export const subCompanyText = {
  fontFamily: 'Inter',
  fontSize: { xl: '16px', lg: '16px', md: '12px', sm: '10px', xs: '10px' },
  fontWeight: 400,
  color: 'rgba(73, 75, 122, 1)',
  textAlign: 'center',
};

export const companyBox = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flexDirection: 'column',
  justifyContent: 'space-around',
  borderRadius: '10px',
  border: '1px solid rgba(225, 225, 225, 1)',
  maxWidth: { xl: '250px', lg: '225px', md: '250px', sm: '200px', xs: '230px' },
  height: { xl: '280px', lg: '260px', md: '280px', sm: '220px', xs: '220px' },
  p: { xl: 2, lg: 2, md: 2, sm: 1, xs: 1 },
};

export const boxColorText = {
  fontFamily: 'Poppins',
  textAlign: 'left',
  fontSize: { xl: '12px', lg: '12px', md: '12px', sm: '10px', xs: '10px' },
  fontWeight: 400,
  color: 'rgba(180, 78, 161, 1)',
  width: '100%',
};

export const boxColorText2 = {
  fontFamily: 'Poppins',
  fontSize: { xl: '15px', lg: '15px', md: '15px', sm: '13px', xs: '13px' },
  fontWeight: 600,
  color: 'rgba(108, 108, 162, 1)',
  width: '100%',
  textAlign: 'left',
  whiteSpace: 'wrap',
};

export const boxColorText3 = {
  fontFamily: 'Poppins',
  fontSize: { xl: '14px', lg: '14px', md: '14px', sm: '12px', xs: '12px' },
  fontWeight: 400,
  color: 'rgba(71, 79, 98, 1)',
  width: '100%',
  textAlign: 'left',
};

export const newsblogBox = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  flexDirection: 'column',
  justifyContent: 'space-around',
  borderRadius: '20px',
  border: '2px solid rgba(247, 247, 247, 1)',
  boxShadow: '0px 10px 10px 5px rgba(162, 182, 212, 0.05)',
  minWidth: { xl: '300px', lg: '300px', md: '300px', sm: '230px', xs: '230px' },
  maxWidth: { xl: '300px', lg: '300px', md: '300px', sm: '230px', xs: '230px' },
  height: { xl: '300px', lg: '300px', md: '300px', sm: '250px', xs: '250px' },
  p: { xl: 2, lg: 2, md: 2, sm: 1, xs: 1 },
  mr: { xl: 0, lg: 0, md: 0, sm: 1, xs: 1 },
};

export const leagalBtn = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  p: 1,
  background: 'rgba(130, 114, 181, 1)',
  borderRadius: '10px',
  fontFamily: 'Poppins',
  fontSize: {
    xl: '12px',
    lg: '12px',
    md: '12px',
    sm: '10px',
    xs: '10px',
  },
  fontWeight: 700,
  color: 'rgba(255, 255, 255, 1)',
  minWidth: '120px',
  maxWidth: '120px',
  mt: 1,
  cursor: 'pointer',
};

export const leagalSubText = {
  fontFamily: 'poppins',
  fontSize: { xl: '16px', lg: '14px', md: '14px', sm: '12px', xs: '12px' },
  fontWeight: 400,
  color: 'rgba(66, 82, 107, 1)',
  width: { xl: '85%', lg: '70%', md: '70%', sm: '95%', xs: '95%' },
  textAlign: { xl: 'left', lg: 'left', md: 'left', sm: 'center', xs: 'center' },
};

export const accordinStylesBox = {
  maxHeight: '480px',
  maxWidth: '730px',
  overflowY: 'auto',
  overflowX: 'hidden',
  width: { xl: '100%', lg: '100%', md: '90%', sm: '100%', xs: '100%' },
  mx: 'auto',
  background: '#fff',
  boxShadow: ' 0px 10px 20px rgba(6, 28, 61, 0.08)',
  borderRadius: '20px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  py: 1,
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(68, 95, 210, 0.8)',
    borderRadius: '6px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'rgba(68, 95, 210, 1)',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'rgb(183, 197, 254)',
    borderRadius: '10px',
  },
};

export const faqMainPage = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: {
    xl: 'row',
    lg: 'row',
    md: 'column-reverse',
    sm: 'column-reverse',
    xs: 'column-reverse',
  },
  p: 2,
  width: '80%',
  mx: 'auto',
  gap: '20px',
};

export const faqQuestionText = {
  fontFamily: 'Poppins',
  fontSize: { xl: '14px', lg: '14px', md: '14px', sm: '12px', xs: '12px' },
  fontWeight: 500,
};

export const faqAnsweText = {
  color: 'rgba(6, 28, 61, 1)',
  fontFamily: 'Poppins',
  fontSize: {
    xl: '12px',
    lg: '12px',
    md: '12px',
    sm: '10px',
    xs: '10px',
  },
  fontWeight: 400,
  width: '100%',
};

export const smallChooseText = {
  fontFamily: 'Poppins',
  fontSize: { xl: '20px', lg: '20px', md: '20px', sm: '12px', xs: '12px' },
  fontWeight: 400,
  textAlign: 'center',
  color: 'rgba(35, 36, 42, 1)',
};

export const slidecolorText = {
  fontFamily: 'Poppins',
  fontSize: { xl: '17px', lg: '17px', md: '17px', sm: '16px', xs: '16px' },
  fontWeight: 600,
  color: 'rgba(108, 108, 162, 1)',
  textAlign: { xl: 'left', lg: 'left', md: 'left', sm: 'center', xs: 'center' },
};

export const slideSubText = {
  fontFamily: 'Poppins',
  fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '14px', xs: '14px' },
  fontWeight: 400,
  color: '#23242A',
  textAlign: { xl: 'left', lg: 'left', md: 'left', sm: 'center', xs: 'center' },
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
};

export const slideSubText2 = { 
  fontFamily: 'Poppins',
  fontSize: { xl: '20px', lg: '16px', md: '16px', sm: '14px', xs: '14px' },
  fontWeight: 400,
  color: 'rgba(0, 0, 0, 1)',
  textAlign: { xl: 'left', lg: 'left', md: 'left', sm: 'center', xs: 'center' },
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
};

export const cardTextBox = {
  textAlign: 'left',
  padding: '0 20px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: {
    xl: 'flex-start',
    lg: 'flex-start',
    md: 'flex-start',
    sm: 'center',
    xs: 'center',
  },
  gap: '10px',
  width: { xl: '20%', lg: '20%', md: '100%', sm: '100%', xs: '100%' },
  mt: { xl: 0, lg: 0, md: 2, sm: 4, xs: 3 },
};

export const cardTextBoxAbove = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: {
    xl: 'row',
    lg: 'row',
    md: 'row',
    sm: 'column-reverse',
    xs: 'column-reverse',
  },
  gap: { xl: 0, lg: 0, md: 0, sm: 2, xs: 2 },
  mt: { xl: 2, lg: 2, md: 2, sm: 2, xs: 2 },
  width: '95%',
  mx: 'auto',
};


